import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useToast } from "../../../design-system/contexts/ToastContext";
import AuthContext from "../../../contexts/AuthContext";

// Auth Components
import { AuthLayout, BackHeader, OTPInput } from "../../../pages/Auth/components";
import "../../../pages/Auth/Auth.css";

const VerifyOtpSignup = ({ state, setState, user, signUp }) => {
  const { success, error: showError } = useToast();
  const navigate = useNavigate();
  const Context = useContext(AuthContext);

  const [counter, setCounter] = useState(30);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [state.receivedOtp && counter]);

  const validateOtp = () => {
    if (!state.data.inputOtp || state.data.inputOtp === "") {
      setState({
        ...state,
        errors: {
          ...state.errors,
          inputOtp: "Please enter OTP",
        },
      });
      return false;
    }
    if (state.data.inputOtp.length !== 6) {
      setState({
        ...state,
        errors: {
          ...state.errors,
          inputOtp: "Please enter complete OTP",
        },
      });
      return false;
    }
    return true;
  };

  const verifyOtp = async () => {
    if (validateOtp()) {
      setState({ ...state, loading: true });
      try {
        const cognitoUser = await Auth.confirmSignUp(
          state.data.email,
          state.data.inputOtp
        );
        if (cognitoUser) {
          success("Account verification successful. You can login to your account now");

          if (!user) {
            setState({
              ...state,
              loading: false,
              userNotConfirmed: false,
              receivedOtp: false,
            });
          } else {
            setState({ ...state });
            Context.setValue({
              user: {
                emailId: state.data.email
              },
              signedIn: false,
              refreshToken: null,
              domain: null,
            });
            navigate(`/login`);
          }
        }
      } catch (err) {
        let error = err.message || "Something went wrong!";
        showError(error);
        console.log(error);
        setState({
          ...state,
          loading: false,
          receivedOtp: true,
          data: { ...state.data, inputOtp: "" },
          errors: {
            ...state.errors,
            inputOtp: "",
          },
        });
      }
    }
  };

  const handleSubmit = () => {
    if (state.receivedOtp) {
      verifyOtp();
    }
  };

  const handleResendOtp = () => {
    if (counter === 0) {
      setCounter(30);
      signUp();
    }
  };

  return (
    <AuthLayout>
      <BackHeader
        title="Enter OTP"
        onBack={() => setState({ ...state, receivedOtp: false, data: { ...state.data, inputOtp: "" } })}
      />

      <p className="auth-description">
        Please enter the OTP we have sent you on {state.data.email}
      </p>

      <div style={{ marginBottom: "var(--spacing-4)" }}>
        <label className="auth-form__label" style={{ marginBottom: "var(--spacing-2)", display: "block" }}>OTP</label>
        <OTPInput
          value={state.data.inputOtp}
          onChange={(otp) => {
            setState({
              ...state,
              data: { ...state.data, inputOtp: otp },
              errors: { ...state.errors, inputOtp: "" },
            });
          }}
          numInputs={6}
          error={state.errors.inputOtp}
        />
      </div>

      <p className="auth-resend">
        Didn't receive an OTP?{" "}
        <span
          className={`auth-resend__link ${counter !== 0 ? "auth-resend__link--disabled" : ""}`}
          onClick={handleResendOtp}
        >
          Resend OTP {counter !== 0 ? `in ${counter} seconds` : ""}
        </span>
      </p>

      <button
        className="auth-btn"
        onClick={handleSubmit}
        disabled={state.loading}
        style={{ marginTop: "var(--spacing-4)" }}
      >
        {state.loading ? <span className="auth-spinner"></span> : "Sign Up"}
      </button>
    </AuthLayout>
  );
};

export default VerifyOtpSignup;
